import {  patch , ApiParameter } from "@insite/client-framework/Services/ApiService";
import {
    BillToModel,
    CartModel,
    ShipToModel,
} from "@insite/client-framework/Types/ApiModels";

export interface UpdateCartApiParameter extends ApiParameter {
    cart: Cart;
}

export interface CartSummaryMethodsResults {
    uri: any;
    cartSummary: CartSummaryMethodsHeader;
    properties: Properties;
}

export interface CartSummaryMethodsHeader {
 countOfFailedItems: number;
discounts: string;
ecoFeeTotal : string;
freight: string;
freightPromoCodeApplied: string;
freightPromoCodeError: string;
listOfOutgoingCarriers: any;
orderTotal: string;
otherCharges: string;
otherTax: string;
promoCodeApplied: string;
promoCodeError: string;
requiredDate: any;
salesTax: string;
taxOnFreight: string;
totalInvoiceAmount: string;
totalLineItemAmount:string;
}

export interface Properties { [key: string]: string };

// export type Cart = Omit<CartModel, "billTo" | "shipTo"> & {
//     billToId?: string;
//     shipToId?: string;
//     collectionShipToLabel?: string;
// };

export type Cart = CartModel & {
    billToId?: string;
    shipToId?: string;
    collectionShipToLabel?: string;
    totalEcoFeeDisplay?: string;
    totalSpecialHandlingFeeDisplay?:String;
};

const cartSummaryUrl = "/api/v1/cart/taxsummary";

export async function getCartSummaryMethods(parameter: UpdateCartApiParameter) {
    const { cart } = parameter;
    //const {shipToId } = cart;
    const patchModel: CartModel = {
        ...cart,
       // billTo: billToId ? ({ id: billToId } as BillToModel) : null,
       // shipTo: shipToId ? ({ id: shipToId } as ShipToModel) : null,
    };
   
    const response = await patch<CartSummaryMethodsResults>(
        cartSummaryUrl,
        patchModel as any,
    );
    return response;
}
